// Simple client-side scraper as fallback
export const fetchProductInfoFallback = async (url) => {
  try {
    // Detect product type from URL and return appropriate mock data
    let mockData;
    
    // Extract product name from URL for better fallback
    const urlParts = url.split('/');
    const lastPart = urlParts[urlParts.length - 2] || urlParts[urlParts.length - 1];
    const productSlug = lastPart.replace(/[^a-zA-Z0-9\s-]/g, ' ').trim();
    
    if (url.includes('power.no')) {
      // Power.no specific handling - extract better info from URL
      let productName = 'Power.no Produkt';
      let description = 'Produkt fra Power.no';
      let category = 'none';
      
      // Extract product name from URL path
      const urlPath = url.split('/').slice(3); // Remove domain parts
      const productParts = urlPath.filter(part => part && !part.includes('p-'));
      
      if (productParts.length > 0) {
        // Reconstruct product name from URL parts
        productName = productParts.map(part => 
          part.split('-').map(word => 
            word.charAt(0).toUpperCase() + word.slice(1)
          ).join(' ')
        ).join(' ');
      }
      
      // Determine category and description based on URL content
      if (url.includes('induksjonskomfyr') || url.includes('komfyr')) {
        productName = 'Electrolux Induksjonskomfyr';
        description = 'Induksjonskomfyr med moderne teknologi og sikkerhetsfunksjoner';
        category = 'home.appliances';
      } else if (url.includes('tv') || url.includes('oled')) {
        productName = 'Smart TV';
        description = 'Smart TV med 4K oppløsning og moderne funksjoner';
        category = 'electronics.tvs';
      } else if (url.includes('hvitevarer')) {
        description = 'Hvitevare med moderne teknologi';
        category = 'home.appliances';
      } else if (url.includes('elektronikk')) {
        description = 'Elektronisk produkt med avansert teknologi';
        category = 'electronics';
      } else if (url.includes('nettbrett') || url.includes('galaxy-tab') || url.includes('samsung-galaxy')) {
        // Samsung tablet
        productName = 'Samsung Galaxy Tab A9 Nettbrett';
        description = 'Android nettbrett med Wi-Fi tilkobling';
        category = 'electronics.phones';
      } else if (url.includes('data-og-tilbehoer') || url.includes('tilbehoer')) {
        description = 'Data og tilbehør produkt';
        category = 'electronics';
      }
      
      mockData = {
        name: productName,
        price: null, // Let user fill in actual price
        image: 'https://via.placeholder.com/300x300?text=Product',
        description: description,
        suggestedCategory: category
      };
    } else if (url.includes('tv') || url.includes('oled') || url.includes('lg-83')) {
      // TV product
      mockData = {
        name: 'LG 83" OLED B5 4K TV 2025',
        price: null,
        image: 'https://via.placeholder.com/300x300?text=TV',
        description: '83-inch OLED 4K Smart TV with AI features',
        suggestedCategory: 'electronics.tvs'
      };
    } else if (url.includes('sykkel') || url.includes('luftkompressor')) {
      // Cycling product
      mockData = {
        name: 'Triacle Airflow One Luftkompressor',
        price: null,
        image: 'https://via.placeholder.com/300x300?text=Bike+Pump',
        description: 'Portable air compressor with power bank',
        suggestedCategory: 'sports.cycling'
      };
    } else if (url.includes('robotstovsuger') || url.includes('robotstoevsuger') || url.includes('robotvacuum') || url.includes('roborock')) {
      // Robot vacuum
      mockData = {
        name: productSlug ? productSlug.split('-').map(word => 
          word.charAt(0).toUpperCase() + word.slice(1)
        ).join(' ') : 'Robotstøvsuger',
        price: null,
        image: 'https://via.placeholder.com/300x300?text=Vacuum',
        description: '', // Leave empty
        suggestedCategory: 'home.appliances'
      };
    } else if (url.includes('airpods') || url.includes('hodetelefoner')) {
      // AirPods or headphones
      mockData = {
        name: url.includes('airpods') ? 'Apple AirPods Pro 3' : (productSlug ? productSlug.split('-').map(word => 
          word.charAt(0).toUpperCase() + word.slice(1)
        ).join(' ') : 'Hodetelefoner'),
        price: null,
        image: 'https://via.placeholder.com/300x300?text=Headphones',
        description: '', // Leave empty
        suggestedCategory: 'electronics.audio'
      };
    } else if (url.includes('mobiltelefoner') || url.includes('mobil') || url.includes('phone') || url.includes('galaxy') || url.includes('iphone') || url.includes('samsung')) {
      // Phone product - extract better name from URL
      const urlPath = url.split('/').filter(part => part && !part.includes('komplett.no') && !part.includes('product'));
      let phoneName = 'Smartphone';
      
      // Try to find model number/name in URL
      const modelKeywords = ['galaxy', 'iphone', 'xperia', 'oneplus', 'xiaomi', 'oppo', 'huawei'];
      for (const part of urlPath) {
        for (const keyword of modelKeywords) {
          if (part.toLowerCase().includes(keyword)) {
            phoneName = part.split('-').map(word => 
              word.charAt(0).toUpperCase() + word.slice(1)
            ).join(' ');
            break;
          }
        }
        if (phoneName !== 'Smartphone') break;
      }
      
      mockData = {
        name: phoneName !== 'Smartphone' ? phoneName : (productSlug ? productSlug.split('-').map(word => 
          word.charAt(0).toUpperCase() + word.slice(1)
        ).join(' ') : 'Smartphone'),
        price: null,
        image: 'https://via.placeholder.com/300x300?text=Phone',
        description: '', // Leave empty instead of generic description
        suggestedCategory: 'electronics.phones'
      };
    } else {
      // Generic product - try to extract name from URL
      mockData = {
        name: productSlug ? productSlug.split('-').map(word => 
          word.charAt(0).toUpperCase() + word.slice(1)
        ).join(' ') : 'Generic Product',
        price: null,
        image: 'https://via.placeholder.com/300x300?text=Product',
        description: 'Product description',
        suggestedCategory: 'none'
      };
    }

    // Simulate network delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    return mockData;
  } catch (error) {
    console.error('Fallback scraper error:', error);
    return null;
  }
};
